import { createContext } from "react";
// import { Socket } from 'socket.io-client'

export const WebsocketContext = createContext<WebSocket | null>(null)
